import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiResponse, ApiResponse2 } from '../classes/apiResponse';
import { AccessSections, User, UserResponse } from '../classes/user';
import { AbstractService } from './abstract.service';
import { RealPlayer } from '../classes/real_player';

@Injectable({
  providedIn: 'root',
})
export class BaseService implements AbstractService{
  public api: string;
  public strEntity: string;
  constructor(protected http: HttpClient) {
    this.api = environment.SERVER_API_PATH;
  }

  public set entity(v: string) {
    this.strEntity = v;
  }

  public get entity(): string {
    return this.strEntity;
  }

  options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  get(id: number): Observable<any> {
    return this.http.get<any[]>(`${this.api}/${this.strEntity}/${id}`, this.options);
  }

  getRels(rel: string): Observable<any> {
    return this.http.get<any[]>(`${this.api}/${rel}`, this.options);
  }

  list(): Observable<ApiResponse<User | any>> {
    return this.http.get<ApiResponse<User | any>>(`${this.api}/${this.strEntity}`, this.options);
  }
  crestFilters(): Observable<ApiResponse2<User | any>> {
    return this.http.get<ApiResponse2<User | any>>(`${this.api}/${this.strEntity}/filters`, this.options);
  }

  list2(filter: Array<any> | null = null, simplified: boolean = false): Observable<ApiResponse2< RealPlayer | User | any>> {
    let pstring = '';
    let params = new URLSearchParams();
    let myOptions = {};
    if (filter) {
      myOptions['params'] = [];
      for (const key in filter) {
        if (Object.prototype.hasOwnProperty.call(filter, key)) {
          const element = filter[key];
          if (element !== ''){
            params.append(key, element);
            myOptions['params'][key]= element;
            
          }
        }
      }
      myOptions['params']['simplified'] = simplified;
      // console.log(params.toString());
      // pstring = '?' + params;
      // myOptions['params'] = {
      //   id: '5'
      // };

    }
    return this.http.get<ApiResponse2< RealPlayer | User | any>>(`${this.api}/${this.strEntity}`, myOptions);
  }
  
  get_by_match_id(realmatch_id: number): Observable<ApiResponse2<RealPlayer | User | any>> {
    const url = `${this.api}/${this.strEntity}/${realmatch_id}`;
    return this.http.get<ApiResponse2<RealPlayer | User | any>>(url);
  }
  get_label_season(): Observable<ApiResponse2<any>>{
    const url = `${this.api}/${this.strEntity}/label`;
    return this.http.get<ApiResponse2<any>>(url);
  }
  get_season_by_realcompetition(rcomp_id, label): Observable<ApiResponse2<any>>{
    let params = ""
    if(label){
      params = `?label=${label}`
    }
    
    const url = `${this.api}/${this.strEntity}/by_realcompetition/${rcomp_id}${params}`;
    return this.http.get<ApiResponse2<any>>(url);
  }
  delete(id: number): Observable<boolean> {
    return this.http.delete<boolean>(`${this.api}/${this.strEntity}/${id}`, this.options);
  }

  updateReals(id: number, record): Observable<any> {
    const body = JSON.stringify(record);
    return this.http.patch(`${this.api}/${this.strEntity}/${id}`, body, this.options);
  }
  
  updateList(record): Observable<any>{
    const body = JSON.stringify(record);
    return this.http.patch(`${this.api}/${this.strEntity}`, body, this.options);
  }
  updateInfo(id, record, info=null): Observable<any>{
    const body = JSON.stringify(record);
    return this.http.patch(`${this.api}/${this.strEntity}/${id}?dataInfo=${info}`, body, this.options);
  }
  getList(filters): Observable<any>{
    let params = new URLSearchParams();
    let myOptions = {};
    if (filters) {
      myOptions['params'] = [];
      myOptions['params']['ids'] = filters
      // for (const key in filters) {
      //   if (Object.prototype.hasOwnProperty.call(filters, key)) {
      //     const element = filters[key];
      //     if (element !== ''){
      //       params.append(key, element);
      //       myOptions['params'][key]= element;
      //       console.log(myOptions)
      //     }
      //   }
      // }
      return this.http.get<ApiResponse2<any>>(`${this.api}/${this.strEntity}/by_realplayers_id`, myOptions);
    }
  }
  update(id: number, record): Observable<any> {
    const body = JSON.stringify(record);
    return this.http.patch(`${this.api}/${this.strEntity}/${id}`, body, this.options);
  }

  create(record: object) {
    const body = JSON.stringify(record);
    return this.http.post(`${this.api}/${this.strEntity}`, body, this.options);
  }
  save(record: object): Observable<ApiResponse2<any>>{
    const body = JSON.stringify(record);
    return this.http.post<ApiResponse2<any>>(`${this.api}/${this.strEntity}/save`, body, this.options);
  }
  

  // getRels(rel: string): Observable<any> {
  //   this.http.get('/' + rel).subscribe(
  //     (data) => {
  //       return ({ class_name: rel, list: data });
  //     },
  //     (err) => {
  //       console.error(err);
  //       alert('ERRORE: ' + JSON.stringify(err.error.description));
  //     }
  //   );
  // }
  // getSeasonRealcompetitions(): Observable<ApiResponse2<any>>{
  //   const url = `${this.api}/${this.strEntity}/rcomps`
  //   return this.http.get<ApiResponse2<any>(url);
  // }

  getSeasonRealcompetitions(rcomp_id): Observable<ApiResponse2<User | any>> {
    return this.http.get<ApiResponse2<User | any>>(`${this.api}/${this.strEntity}/realcompetition/${rcomp_id}`, this.options);
  }
  saveSeasonrealcompetitions(rcomp_id, record: any[]) {
    const body = JSON.stringify(record);
    return this.http.patch(`${this.api}/${this.strEntity}/realcompetition/${rcomp_id}`, body, this.options);
    
  }
  getAuthAccesstoSections(): Observable<ApiResponse2<AccessSections | any>>{
    return this.http.get<ApiResponse2<AccessSections | any>>(`${this.api}/user-authorization`, this.options);
  }

  getUserRole(): Observable<ApiResponse2<any>>{
    return this.http.get<ApiResponse2<any>>(`${this.api}/user-role`, this.options);
  }
  hasCrestListItems(type_id): Observable<ApiResponse2<any>>{
    return this.http.get<ApiResponse2<any>>(`${this.api}/${this.strEntity}/items?cresttype_id=${type_id}`, this.options);

  }
  getUserRoles(): Observable<ApiResponse2<any>>{
    return this.http.get<ApiResponse2<any>>(`${this.api}/user-roles`, this.options);
  }
}
